/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharestatusheld2Inputs */

const en_sharestatusheld2 = /** @type {(inputs: Sharestatusheld2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`under review`)
};

const de_sharestatusheld2 = /** @type {(inputs: Sharestatusheld2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`wird geprüft`)
};

/**
* | output |
* | --- |
* | "under review" |
*
* @param {Sharestatusheld2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharestatusheld2 = /** @type {((inputs?: Sharestatusheld2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharestatusheld2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharestatusheld2(inputs)
	return de_sharestatusheld2(inputs)
});
export { sharestatusheld2 as "shareStatusHeld" }